import { createApi } from '@reduxjs/toolkit/query/react';
import { API_URL } from '../../config/constant';
import { axiosBaseQuery } from './axiosBaseQuery';

export const baseApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: API_URL,
  }),
  endpoints: () => ({}),
});
